// import {cleanObj, debugLog} from '../utils'
import {IxDelete, IxPost, IxPut} from '../IxPlugin/api'
import Vue from 'vue'


/**
 * so Ajv is 109Kb on it's own. It's kinda big, so we want to not bundle it
 * with our main app.js. but it's returning a promise and we want an object.
 * So first we set up our import
 */
// const Ajv = ()=>import(/* webpackChunkName:'ajv' */'ajv')
let $ajv = new window.Ajv({allErrors: true})

class IxModel{
  constructor(base){
    this.errors = []
    let defaults = this.defaults()
    if (base instanceof Object){
      let keys = Object.keys(defaults)
      for (let i in keys){
        let x = keys[i]
        this[x] = typeof base[x] !== 'undefined'?base[x]:defaults[x]
      }
      //Object.assign(this,defaultIxAddress,base)
    }

    /**
     * To instantiate our Ajv validator that we've dynamically imported,
     * we have to do it in a promise. This makes it look really funny.
     */


  }

  $ajv(){
    return $ajv
  }

  _handleResponse(response){
    if (response.status === 201 || response.status === 200){
      let newthing = response.data,
          keys = Object.keys(this.defaults())
      for (let i in keys){
        let x = keys[i]
        this[x] = newthing[x]
      }
    }
    return Promise.resolve(response)
  }

  __create(){
    return IxPost(this.address(), this)
        .then(data=>this._handleResponse(data))
  }

  __update(){
    return IxPut(this.url, this)
        .then(data=>this._handleResponse(data))
  }

  save(){
    if (this.url !== ''){
      return this.__update()
    }else{
      return this.__create()
    }
  }

  delete(){
    if (this.url !== ''){
      return IxDelete(this.url)
    }else{
      return Promise.reject({message: 'This Model does not have a url.'})
    }
  }

  validate(){
    let validate = this.validator(),
        result = validate(this),
        errors = validate.errors?validate.errors:[]
    Vue.set(this, 'errors', errors)
    return result
  }

  defaults(){
    throw 'Method default() not defined!'
  }

  address(){
    throw 'Method address() not defined!'
  }

  validator(){
    throw 'Method validator() not defined!'
  }

  schema(){
    throw 'Method schema() not defined!'
  }

  getErrors(path){
    return this.errors.filter(e=>e.dataPath === '.' + path)
  }

  getLabel(path){
    let properties = this.schema().properties
    if (typeof properties[path] !== 'undefined'){
      if (typeof properties[path].label !== 'undefined'){
        return properties[path].label
      }
    }
    return path
  }
}


export default IxModel


// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/classes/_ix-model.js